import { render } from "./CreateGroupAndSubGroup.vue?vue&type=template&id=dcdc3948&scoped=true"
import script from "./CreateGroupAndSubGroup.vue?vue&type=script&lang=js"
export * from "./CreateGroupAndSubGroup.vue?vue&type=script&lang=js"

import "./CreateGroupAndSubGroup.vue?vue&type=style&index=0&id=dcdc3948&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdc3948"]])

export default __exports__